<template>
    <div v-show="active" :id="paneId" :class="['tab-pane', 'fade', active && 'show active']" role="tabpanel" :aria-labelledby="tabId" :aria-hidden="String(!active)" tabindex="0"><slot /></div>
</template>
<script>
export default {
    name: "SbTab",
    inject: { sbTabs: { default: null } },
    props: {
        title: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        titleItemClass: { type: [String, Array, Object], default: null },
    },
    computed: {
        active() { return this.sbTabs ? this.sbTabs.tabs.indexOf(this) === this.sbTabs.activeIndex : true; },
        tabId() { return this.sbTabs?.tabId(this) || null; },
        paneId() { return this.sbTabs?.paneId(this) || null; },
    },
    mounted() { this.sbTabs?.register(this); },
    beforeUnmount() { this.sbTabs?.unregister(this); },
};
</script>
